/// <reference path="../../../typings/index.d.ts" />
/// <reference path="../apimodel.d.ts" />

module App.Common {

	export class HiLOUser implements Hca.HiLO.ViewModel.IUserViewModel {

		constructor(userData: Hca.HiLO.ViewModel.IUserViewModel = null) {
			if (userData) {
				_.extend(this, userData);
			}
		}

		public amesPanelManager: string;
		public delegationLevel: number;
		public department: string;
		public directorate: string;
		public emailAddress: string;
		public firstName: string;
		public fullName: string;
		public isActiveUser: boolean;
		public isInternalUser: boolean;
		public jobTitle: string;
		public lineManagerId: string;
		public lineManagerName: string;
		public mobileNumber: string;
		public officeAddress: Hca.HiLO.ViewModel.IAddressViewModel;
		public officeLocation: string;
		public permissions: Hca.HiLO.Model.Identity.Permissions[];
		public roles: Hca.HiLO.Model.Identity.Roles[];
		public surname: string;
		public telephoneNumber: string;
		public username: string;
		public editable: boolean;
		public id: string;
		public name: string;
		public state: Hca.HiLO.ObjectState;

		public hasPermission(permission: Hca.HiLO.Model.Identity.Permissions): boolean {
			return _(this.permissions).some(x => x === permission);
		}

		public hasRole(role: Hca.HiLO.Model.Identity.Roles): boolean {
			return _(this.roles).some(x => x === role);
		}

	}

}